export default {
  simulationData: 'Dane symulacyjne',
  showPreview: 'Podgląd przepisu symulatora',
  selectUnitHeader: 'System jednostek',
  timeoutSeconds: 'Maksymalny czas symulacji',
};
